import { type ReactElement, useCallback } from 'react'
import ReactDOMServer from 'react-dom/server'

import { useCtaTracking } from '@lib/hooks/use-cta-tracking'

import { getConfig } from '@config/index'

import { ComponentCtaButtonType } from '@constants/enums/cta'

import { type AuthCtaButtonProps } from '@components/cta/cta-prop-types'
import { Button } from '@components/ui-core/button/button'

const config = getConfig()

const signupUrl = `${config.api.signup}?screen_hint=signup`
const signinUrl = config.api.signin

function AuthCtaButton(
  props: AuthCtaButtonProps & {
    type: ComponentCtaButtonType.Signup | ComponentCtaButtonType.Signin
  },
): ReactElement {
  const { text, isCompact, category = 'primary', type, ...restProps } = props
  const targetUrl = type === ComponentCtaButtonType.Signin ? signinUrl : signupUrl
  const { trackAndNavigate, isLoading } = useCtaTracking({ placement: 'Section' })

  const onClick = useCallback(async () => {
    trackAndNavigate(
      type,
      ReactDOMServer.renderToString(text),
      category === 'unstyled' ? 'text' : category,
      targetUrl,
    )
  }, [targetUrl, text, category, type, trackAndNavigate])

  return (
    <Button
      category={category}
      isCompact={isCompact}
      isLoading={isLoading}
      text={text}
      onClick={onClick}
      href={targetUrl}
      {...restProps}
    />
  )
}

export function SignupCtaButton(props: AuthCtaButtonProps): ReactElement {
  return <AuthCtaButton {...props} type={ComponentCtaButtonType.Signup} />
}
export function SigninCtaButton(props: AuthCtaButtonProps): ReactElement {
  return <AuthCtaButton {...props} type={ComponentCtaButtonType.Signin} />
}
